import { render, staticRenderFns } from "./MeasurementProtocolSummary.vue?vue&type=template&id=98bb2526&scoped=true&"
import script from "./MeasurementProtocolSummary.vue?vue&type=script&lang=js&"
export * from "./MeasurementProtocolSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bb2526",
  null
  
)

export default component.exports